import { createApp } from 'vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import ElementPlus from 'element-plus'

import { createGtm } from '@gtm-support/vue-gtm'
import { createBootstrap } from 'bootstrap-vue-next'
import VueSweetalert2 from 'vue-sweetalert2'
import { getFullPath } from './utils/obpath'

// 引入jquery
// import $ from 'jquery';
// window.$ = $;

import moment from 'moment'
window.moment = moment

// Add the necessary CSS
import '@/assets/css/raw_theme.min.css' //ui中的库
import '@/assets/css/vendors.min.css' // 图标库
import 'element-plus/dist/index.css'
import '@/assets/css/bootstrap.min.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'sweetalert2/dist/sweetalert2.min.css'

// import js
import 'bootstrap/dist/js/bootstrap.min.js'

// 创建app
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'
const app = createApp(App)
app.config.globalProperties.appVersion = app.version

// 全局存储
import stores from './stores'
app.use(stores)

//路由信息
import router from './router'
app.use(router)

// 导航守卫
import { useUserStore } from 'obst/user-store'
const userStore = useUserStore()
router.beforeEach((to, from, next) => {
  const { meta, name } = to
  // 登录状态解析
  const { noLogin } = meta
  if (!noLogin) {
    // 需要登陆才可以访问的页面
    if (!userStore.token && name != 'login') {
      //token不存在，重定向到登录页面
      window.location = getFullPath('/auth/login')
      return
    }
  }
  next()
})

// 提示
app.use(VueSweetalert2)
// vuestic框架
app.use(createVuestic({ config: vuesticGlobalConfig }))
// bootstrap框架
app.use(createBootstrap()) // bootstrapvue
//elementpul框架
app.use(ElementPlus)
// 国际化
app.use(i18n)

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')
